//  +----------------------------------------------------------------------
//  | 球友会 [ 关于台球，就用球友汇 ]
//  +----------------------------------------------------------------------
//  | Copyright (c) 2025 https://www.qyxtyfz.com All rights reserved.
//  +----------------------------------------------------------------------

export default {
	token: state => state.app.token,
	isLogin: state => !!state.app.token,
	backgroundColor: state => state.app.backgroundColor,
	userInfo: state => state.app.userInfo || {},
	uid: state => state.app.uid,
	homeActive: state => state.app.homeActive,
	home: state => state.app.home,
	chatUrl: state => {
		const url = state.app.chatUrl;
		const uid = state.app.uid;
		if (!url || !uid) return url;
		return url + (url.includes('?') ? '&' : '?') + 'userid=' + uid;
	},
	systemPlatform: state => state.app.systemPlatform,
	productType: state => state.app.productType,
	bottomNavigationIsCustom: state => state.app.bottomNavigationIsCustom,
	globalData: state => state.app.globalData,
};
